"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {},
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {}
};
/**
 * Provides wrapper for MenuItems to create clickable and decorated list
 */
var Menu = exports["default"] = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Menu, _Component);
  function Menu(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Menu);
    _this = _callSuper(this, Menu, [props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (event) {
      var onClick = _this.props.onClick;
      onClick(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleArrowKeyDown", function (key) {
      if (!_this.childRefs.length) {
        return;
      }
      var selectedIndex = _this.state.selectedIndex;
      var newSelectedIndex;
      switch (key) {
        case 'ArrowUp':
          newSelectedIndex = _this.getPrevIndex(selectedIndex);
          break;
        case 'ArrowDown':
          newSelectedIndex = _this.getNextIndex(selectedIndex);
          break;
        default:
          return;
      }
      _this.childRefs[newSelectedIndex].focus();
      _this.setState({
        selectedIndex: newSelectedIndex
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (event) {
      var onKeyDown = _this.props.onKeyDown;
      var key = event.key;
      if (key === 'ArrowUp' || key === 'ArrowDown') {
        event.preventDefault();
        _this.handleArrowKeyDown(key);
      }
      onKeyDown(event);
    });
    _this.state = {
      selectedIndex: -1
    };
    _this.childRefs = [];
    _this.childClickActions = [];
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(Menu, [{
    key: "getNextIndex",
    value: function getNextIndex(actualIndex) {
      if (actualIndex === -1) {
        return 0;
      }
      var next = actualIndex === this.childRefs.length - 1 ? 0 : actualIndex + 1;
      if (!this.childRefs[next]) {
        return this.getNextIndex(next);
      }
      return next;
    }
  }, {
    key: "getPrevIndex",
    value: function getPrevIndex(actualIndex) {
      if (actualIndex === -1) {
        return this.childRefs.length - 1;
      }
      var prev = actualIndex === 0 ? this.childRefs.length - 1 : actualIndex - 1;
      if (!this.childRefs[prev]) {
        return this.getPrevIndex(prev);
      }
      return prev;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props = this.props,
        title = _this$props.title,
        theme = _this$props.theme,
        testId = _this$props.testId;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(theme.titleContainer, " popover-if-clicked-ignore-close"),
        "data-test-id": testId && "".concat(testId, "-title-container")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(theme.title, " popover-if-clicked-ignore-close"),
        "data-test-id": testId && "".concat(testId, "-title")
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        title = _this$props2.title,
        className = _this$props2.className,
        children = _this$props2.children,
        theme = _this$props2.theme,
        testId = _this$props2.testId;
      var classes = (0, _classnames["default"])(className, /* user specified classNames */
      theme.menu);
      return /*#__PURE__*/_react["default"].createElement("div", {
        role: "menu",
        className: classes,
        "data-test-id": testId,
        "data-anypoint-component": Menu.displayName,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        tabIndex: "0"
      }, title && this.renderTitle(), _react["default"].Children.map(children, function (child, index) {
        if (!child || child.type.displayName !== 'MenuItem') {
          return child;
        }
        var result = /*#__PURE__*/_react["default"].cloneElement(child, {
          getRef: function getRef(elem) {
            return _this2.childRefs[index] = elem;
          },
          tabIndex: '-1'
        });
        return result;
      }));
    }
  }]);
  return Menu;
}(_react.Component);
(0, _defineProperty2["default"])(Menu, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(Menu, "displayName", 'Menu');
//# sourceMappingURL=Menu.js.map